// =========================
// Heista DIRECTIVES
// =========================
import "./app/directives/startOwl";

import "gsap";
//import "TimelineMax";
//import "TweenLite";
import "TweenMax";
//import ScrollMagic from "ScrollMagic";
//import "animation.gsap";
//import "debug.addIndicators";


// =========================
// Heista Components
// =========================
Vue.component("heista-stepper", () => import("./app/components/HeistaStepper.vue"));
Vue.component("heista-checkout-info", () => import("./app/components/HeistaCheckoutInfo.vue"));
Vue.component("heista-opener", () => import("./app/components/HeistaOpener.vue"));
Vue.component("heista-image-hover", () => import("./app/components/HeistaImageHover.vue"));
Vue.component("staggered-fade", () => import("./app/components/StaggeredFade.vue"));
Vue.component("heista-image-mileu-first", () => import("./app/components/HeistaImageMileuFirst.vue"));
Vue.component("heista-category-item-eigenschaften", () => import("./app/components/HeistaCategoryItemEigenschaften.vue"));
Vue.component("heista-item-filter", () => import("./app/components/HeistaItemFilter.vue"));
Vue.component("heista-item-availability", () => import("./app/components/HeistaItemAvailability.vue"));
Vue.component("item-icon-properties", () => import("./app/components/ItemIconProperties.vue"));
Vue.component("article-carousel", () => import("./app/components/ArticleCarousel.vue"));
// Vue.component("single-add-to-basket", () => import("./app/components/SingleAddToBasket.vue"));


/*
// init controller
var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

// build scenes 
var t1 = new TimelineMax();
t1.from("#content-section1",0.5 ,{"--scale":0.86, transformOrigin:"center", ease: Power1.easeOut});
t1.to("#content-section1",0.5 ,{"--scale":0.86, transformOrigin:"center", ease: Power1.easeOut},"+=0.5");
t1.from("#content-section1 .content",0.5 ,{opacity:0, transformOrigin:"center", ease: Power1.easeOut},0);

var t2 = new TimelineMax();
t2.from("#content-section2",0.5 ,{"--scale":0.86, transformOrigin:"center", ease: Power1.easeOut});
t2.to("#content-section2",0.5 ,{"--scale":0.86, transformOrigin:"center", ease: Power1.easeOut});
t2.from("#content-section2 .content",0.5 ,{opacity:0, transformOrigin:"center", ease: Power1.easeOut},0);

var t3 = new TimelineMax();
t3.from("#content-section3",0.5 ,{"--scale":0.86, transformOrigin:"center", ease: Power1.easeOut});
t3.to("#content-section3",0.5 ,{"--scale":0.86, transformOrigin:"center", ease: Power1.easeOut});
t3.from("#content-section3 .content",0.5 ,{opacity:0, transformOrigin:"center", ease: Power1.easeOut},0);

//
new ScrollMagic.Scene({triggerElement: "#content-section1"})
        .setTween(t1)
        .addIndicators()
        .addTo(controller);

new ScrollMagic.Scene({triggerElement: "#content-section2"})
        .setTween(t2)
        .addIndicators()
        .addTo(controller);

new ScrollMagic.Scene({triggerElement: "#content-section3"})
        .setTween(t3)
        .addIndicators()
        .addTo(controller);
*/
